import { render, staticRenderFns } from "./SCard.vue?vue&type=template&id=40cc44d3&scoped=true&"
import script from "./SCard.vue?vue&type=script&lang=js&"
export * from "./SCard.vue?vue&type=script&lang=js&"
import style0 from "./SCard.vue?vue&type=style&index=0&id=40cc44d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cc44d3",
  null
  
)

export default component.exports